var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"footer",staticClass:"sb-footer",class:{ 'is-desktop': !_vm.isMobile }},[_c('div',{staticClass:"sb-footer-row"},[_c('Controls'),_c('SpinButton',{attrs:{"spinButtonIsActive":_vm.spinButtonIsActive},on:{"onButtonClick":_vm.handleSpinClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }